import { ConnectDomainParams } from '../../params/redux/domain';
import { createAsyncThunk } from '@reduxjs/toolkit';
import DomainApi from '../../apis/domain';
import { errorHandler } from '../../helper/error_handler';
import { isErrorWithMessage } from '../../helper';
import { resettingDomainLoader } from '../slices/domain';
import { RootState } from '../../redux/store';

export const fetchDomainsThunk = createAsyncThunk(
    'domain/fetch',
    async (_, { dispatch, rejectWithValue, getState }): Promise<unknown> => {
        try {
            const state = getState() as RootState;
            const response = await DomainApi.fetchDomains(state.app.token);
            if (response?.success === 1) {
                return response.website || null;
            }
            return errorHandler(response?.msg as string || 'Request Failed', dispatch, rejectWithValue);
        } catch (error) {
            if (isErrorWithMessage(error)) {
                return errorHandler(error.message, dispatch, rejectWithValue);
            }
            return errorHandler('An unknown error occurred', dispatch, rejectWithValue);
        } finally {
            dispatch(resettingDomainLoader());
        }
    }
);

export const fetchDomainDNSThunk = createAsyncThunk(
    'domain/fetch-dns',
    async (_, { dispatch, rejectWithValue, getState }): Promise<unknown> => {
        try {
            const state = getState() as RootState;
            const response = await DomainApi.getDomainDNS(state.app.token);
            if (response?.success === 1) {
                return response.website || null;
            }
            return errorHandler(response?.msg as string || 'Request Failed', dispatch, rejectWithValue);
        } catch (error) {
            if (isErrorWithMessage(error)) {
                return errorHandler(error.message, dispatch, rejectWithValue);
            }
            return errorHandler('An unknown error occurred', dispatch, rejectWithValue);
        } finally {
            dispatch(resettingDomainLoader());
        }
    }
);

export const connectDomainThunk = createAsyncThunk(
    'domain/connect',
    async (data: ConnectDomainParams, { dispatch, rejectWithValue, getState }): Promise<unknown> => {
        try {
            const state = getState() as RootState;
            const response = await DomainApi.connectDomain(state.app.token, data);
            if (response?.success === 1) {
                await dispatch(fetchDomainsThunk()).unwrap();
                return true;
            }
            return errorHandler(response?.msg as string || 'Request Failed', dispatch, rejectWithValue);
        } catch (error) {
            if (isErrorWithMessage(error)) {
                return errorHandler(error.message, dispatch, rejectWithValue);
            }
            return errorHandler('An unknown error occurred', dispatch, rejectWithValue);
        } finally {
            dispatch(resettingDomainLoader());
        }
    }
);

export const disconnectDomainThunk = createAsyncThunk(
    'domain/disconnect',
    async (_, { dispatch, rejectWithValue, getState }): Promise<unknown> => {
        try {
            const state = getState() as RootState;
            const response = await DomainApi.disconnectDomain(state.app.token);
            if (response?.success === 1) {
                await dispatch(fetchDomainsThunk()).unwrap();
                return true;
            }
            return errorHandler(response?.msg as string || 'Request Failed', dispatch, rejectWithValue);
        } catch (error) {
            if (isErrorWithMessage(error)) {
                return errorHandler(error.message, dispatch, rejectWithValue);
            }
            return errorHandler('An unknown error occurred', dispatch, rejectWithValue);
        } finally {
            dispatch(resettingDomainLoader());
        }
    }
);

export const updateDomainThunk = createAsyncThunk(
    'domain/update',
    async (data: ConnectDomainParams, { dispatch, rejectWithValue, getState }): Promise<unknown> => {
        try {
            const state = getState() as RootState;
            const response = await DomainApi.updateDomain(state.app.token, data);
            if (response?.success === 1) {
                await dispatch(fetchDomainsThunk()).unwrap();
                return true;
            }
            return errorHandler(response?.msg as string || 'Request Failed', dispatch, rejectWithValue);
        } catch (error) {
            if (isErrorWithMessage(error)) {
                return errorHandler(error.message, dispatch, rejectWithValue);
            }
            return errorHandler('An unknown error occurred', dispatch, rejectWithValue);
        } finally {
            dispatch(resettingDomainLoader());
        }
    }
);

